module.exports = __webpack_public_path__ + "img/Helfer_SGL.5909126d.svg";